import { Component, OnInit } from '@angular/core';
import {ApiLoadingService} from "../../../core/loading/api-loading.service";
import {Observable} from "rxjs";

@Component({
    selector: 'cml-main-layout',
    templateUrl: './main-layout.component.html',
    styleUrls: ['./main-layout.component.scss'],
    standalone: false
})
export class MainLayoutComponent implements OnInit {
  isApiCommunicating$: Observable<boolean>
  = this.apiComms.$isCommunicating

  constructor(private apiComms: ApiLoadingService) { }

  ngOnInit(): void {
  }

}
